import { render, staticRenderFns } from "./CommunityHome.vue?vue&type=template&id=019aa9ea&scoped=true&"
import script from "./CommunityHome.vue?vue&type=script&lang=js&"
export * from "./CommunityHome.vue?vue&type=script&lang=js&"
import style0 from "./CommunityHome.vue?vue&type=style&index=0&id=019aa9ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019aa9ea",
  null
  
)

export default component.exports